import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter, useSearchParams } from 'next/navigation';
import {
  resetProductFilters,
  updateFilters,
} from '@/redux/reducers/products-reducer';
import { cn } from '@/utils/cn';
import { getProductCategoryUrl } from '@/url/product';
import Link from 'next/link';
import { closeAllMenu } from '@/redux/reducers/hamburger-menu-reducer';
import Text from '../Text';

function SubMenuItemCard({ data, activeSubMenuId, type = '' }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const dispatch = useDispatch();

  const handleItemClick = async (e, item) => {
    e.stopPropagation();

    if (type === 'product-categories') {
      // Build query params
      const params = new URLSearchParams(searchParams);
      params.set('category', item.slug);

      // Update store filters
      dispatch(
        updateFilters({
          category: item.slug,
          page: 1,
          limit: 12,
        }),
      );

      // Update the url
      // const url = `/category/${data.slug}?${params.toString()}`;
      const url = getProductCategoryUrl({
        slug: data.slug,
        childrenSlug: item.slug,
      });

      router.push(url);
      setTimeout(() => {
        dispatch(closeAllMenu());
      }, 1000);
    }
  };

  const handleNavigateCategoryPage = (item) => {
    dispatch(resetProductFilters());
    router.push(
      getProductCategoryUrl({ slug: data.slug, childrenSlug: item.slug }),
    );
    setTimeout(() => {
      dispatch(closeAllMenu());
    }, 1000);
  };

  return (
    <div
      className={cn(
        'origin-top w-full overflow-hidden transition-transform duration-100 ease-in-out hover:cursor-pointer',
        {
          'scale-y-0': activeSubMenuId !== data.id,
          'scale-y-100': activeSubMenuId === data.id,
        },
      )}
    >
      {data?.children.length > 0 && (
        <div className="w-full flex flex-col gap-3 px-16">
          {data?.children?.map((item) => (
            <Fragment key={item.slug}>
              {type === 'product-categories' ? (
                <Link
                  prefetch={false}
                  aria-label="Go to product category page"
                  href={getProductCategoryUrl({
                    slug: data.slug,
                    childrenSlug: item.slug,
                  })}
                  onClick={() => handleNavigateCategoryPage(item)}
                >
                  <Text
                    key={item.slug}
                    type="paragraph"
                    className="text-14 text-coarse-wool font-medium font-encode-sans leading-20 tracking-[0.28px] py-4"
                    // onClick={(e) => handleItemClick(e, item)}
                  >
                    {item.name?.en}
                  </Text>
                </Link>
              ) : (
                <Text
                  key={item.slug}
                  type="paragraph"
                  className="text-14 text-coarse-wool font-medium font-encode-sans leading-20 tracking-[0.28px] py-4"
                  onClick={(e) => handleItemClick(e, item)}
                >
                  {item.label}
                </Text>
              )}
            </Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default SubMenuItemCard;
